import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlane,
  faPhone,
  faUser,
  faChevronRight,
  faEnvelope,
  faCopy,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { mockFlights } from "../data/mockFlights";
import { airlines } from "../data/airlines";
import { config } from "../config";
import Header from "../components/Header";

function ManageBooking() {
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const flight = mockFlights[1];
  const airline = airlines[flight.operatorCode];

  // Hardcoded passenger data
  const passengers = [
    {
      id: 1,
      firstName: "Josh",
      lastName: "Sparkes",
      type: "Adult",
      dob: "05 Dec 1989",
      bookingClass: "Economy",
    },
    {
      id: 2,
      firstName: "Jane",
      lastName: "Sparkes",
      type: "Child",
      dob: "15 Mar 2018",
      bookingClass: "Economy",
    },
  ];

  // Hardcoded contact info
  const contactInfo = {
    name: "Josh Sparkes",
    email: "joshsparkes6@gmail.com",
    phone: "+44 749329167",
  };

  // Support info
  const supportInfo = {
    phone: "+44 (0) 20 7123 4567",
    email: "support@travelwebsite.com",
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    // You could add a toast notification here
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto py-8 px-4">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-2xl font-bold flex items-center gap-2">
              {flight.origin} <FontAwesomeIcon icon={faPlane} size="sm" />{" "}
              {flight.destination}
            </h1>
            <p className="text-gray-600">
              {flight.outbound_date} • {flight.return_date}
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Booking Reference: AMT123456
            </p>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold">£{flight.price}.00</p>
            <p className="text-gray-600">Total paid</p>
          </div>
        </div>

        {/* Flight Summary */}
        <div className="bg-white rounded-lg p-6 mb-6 shadow-sm">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faPlane} className={`text-${config.primaryColor}`} />
            </div>
            <div>
              <h2 className="text-lg font-semibold">Your flights</h2>
            </div>
          </div>

          {/* Flight Details */}
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 bg-white rounded-lg p-1.5 flex items-center justify-center border border-gray-100">
                <img src={airline.logo} alt={airline.name} className="w-full h-full object-contain" />
              </div>
              <div>
                <p>{airline.name} • {flight.duration} • Direct</p>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <span>LHR {flight.outbound_time}</span>
                  <FontAwesomeIcon icon={faChevronRight} size="xs" />
                  <span>CDG {flight.outbound_arrival_time}</span>
                </div>
              </div>
            </div>

            {flight.return_date && (
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-white rounded-lg p-1.5 flex items-center justify-center border border-gray-100">
                  <img src={airline.logo} alt={airline.name} className="w-full h-full object-contain" />
                </div>
                <div>
                  <p>{airline.name} • {flight.return_duration} • Direct</p>
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <span>CDG {flight.return_time}</span>
                    <FontAwesomeIcon icon={faChevronRight} size="xs" />
                    <span>LHR {flight.return_arrival_time}</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Passenger Details */}
        <div className="bg-white rounded-lg p-6 mb-6 shadow-sm">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faUser} className={`text-${config.primaryColor}`} />
            </div>
            <div>
              <h2 className="text-lg font-semibold">Passenger Details</h2>
            </div>
          </div>

          <div className="space-y-6">
            {passengers.map((passenger) => (
              <div key={passenger.id} className="flex items-center gap-4 border-b pb-4 last:border-b-0 last:pb-0">
                <div className="bg-coral-100 rounded-full w-12 h-12 flex items-center justify-center text-xl font-semibold text-coral-600">
                  {passenger.firstName[0]}{passenger.lastName[0]}
                </div>
                <div className="flex-grow">
                  <p className="font-semibold">{passenger.firstName} {passenger.lastName}</p>
                  <p className="text-gray-600">{passenger.type} • {passenger.dob}</p>
                  <p className="text-sm text-gray-500">Booking Class: {passenger.bookingClass}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Information */}
        <div className="bg-white rounded-lg p-6 mb-6 shadow-sm">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faPhone} className={`text-${config.primaryColor}`} />
            </div>
            <div>
              <h2 className="text-lg font-semibold">Contact Information</h2>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <p className="text-gray-600">Lead Passenger</p>
              <p className="font-semibold">{contactInfo.name}</p>
            </div>
            <div>
              <p className="text-gray-600">Email</p>
              <p className="font-semibold">{contactInfo.email}</p>
            </div>
            <div>
              <p className="text-gray-600">Phone</p>
              <p className="font-semibold">{contactInfo.phone}</p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4">
          <button
            onClick={() => setIsSupportModalOpen(true)}
            className="flex-1 bg-red-500 text-white py-4 rounded-full hover:bg-red-600 transition-colors text-lg font-semibold"
          >
            Cancel Trip
          </button>
          <button
            onClick={() => setIsSupportModalOpen(true)}
            className={`flex-1 bg-${config.primaryColor} text-white py-4 rounded-full hover:bg-purple-700 transition-colors text-lg font-semibold`}
          >
            Change Information
          </button>
        </div>

        {/* Support Modal */}
        {isSupportModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-md p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-bold">Contact Support</h3>
                <button
                  onClick={() => setIsSupportModalOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>

              <p className="text-gray-600 mb-6">
                Please contact our support team for assistance with your booking:
              </p>

              <div className="space-y-4">
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center gap-3">
                    <FontAwesomeIcon icon={faPhone} className="text-gray-600" />
                    <span>{supportInfo.phone}</span>
                  </div>
                  <button
                    onClick={() => copyToClipboard(supportInfo.phone)}
                    className="text-blue-600 hover:text-blue-700"
                  >
                    <FontAwesomeIcon icon={faCopy} />
                  </button>
                </div>

                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <div className="flex items-center gap-3">
                    <FontAwesomeIcon icon={faEnvelope} className="text-gray-600" />
                    <span>{supportInfo.email}</span>
                  </div>
                  <button
                    onClick={() => copyToClipboard(supportInfo.email)}
                    className="text-blue-600 hover:text-blue-700"
                  >
                    <FontAwesomeIcon icon={faCopy} />
                  </button>
                </div>
              </div>

              <p className="text-sm text-gray-500 mt-6">
                Our support team is available 24/7 to assist you with any changes or cancellations.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ManageBooking;